import React from 'react';
import { Link, LinkProps } from '@reach/router';

export function LinkMaybe<TState>(
  props: React.PropsWithoutRef<Omit<LinkProps<TState>, 'to'> & { to?: string | null }> &
    React.RefAttributes<HTMLAnchorElement>
): ReturnType<Link<TState>> {
  const { children, to, ...rest } = props;
  if (!to) {
    return <span {...rest}>{children}</span>;
  }

  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
}

export default LinkMaybe;
